
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog },
  props: {
    dialog: Boolean
  },
  data() {
    return {
      priceRanges: [
        { range: "0 - 49", price: "5.00" },
        { range: "50 - 150", price: "7.00" },
        { range: "151 - 300", price: "10.00" },
        { range: "301 - 500", price: "15.00" },
        { range: "500+", price: "20.00" }
      ]
    };
  }
};
